var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ac > 0)?_c('Tooltip',{attrs:{"placement":"top","content":`Possui ${_vm.ac} ticket${_vm.ac > 1 ? 's' : '' } associado${_vm.ac > 1 ? 's' : ''}`}},[_c('Icon',{style:({fontSize: '22px', color: '#515a73'}),attrs:{"type":"ios-link"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }